module.exports = __webpack_public_path__ + "img/task5.d0e19ea2.png";